import {
  formatCalcName,
  formatCurrency,
  getBeforeTaxInfo,
  getFormattedApplicantsInfo,
  getRelationshipInfo,
} from "../../../../utils";

const components: { [key: string]: any } = {
  action: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "I want to refinance",
      "2": "I want to buy a home",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  property_price: (label: string, value: string) => {
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{formatCurrency(value)}</div>
      </li>
    );
  },
  deposit_amount: (label: string, value: string) => {
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{formatCurrency(value)}</div>
      </li>
    );
  },
  home_buying_situation: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Just exploring options",
      "2": "Plan to buy in next 6 months",
      "3": "Actively looking / Made an offer",
      "4": "Exchanged contracts",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  you_looking_to_buy: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Newly built / Off the plan",
      "2": "Established home",
      "3": "Vacant land to build on",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  howUsed: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "I will live there",
      "2": "It's an investment",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  repay: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Principal and interest",
      "2": "Interest only",
      "3": "Still deciding",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  important: (label: string, value: any) => {
    // const actionLookup: { [key: string]: string } = {
    //     "1": "Offset/Redraw",
    //     "2": "Fixed rate",
    //     "3": "Major lender",
    //     "4": "Mobile app",
    //   };
    const isArray = typeof value === "object" && Array.isArray(value);
    const originalValue = isArray ? value.join(", ") : value?.preferences;
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{originalValue}</div>
      </li>
    );
  },
  applicants_number: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  will: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "One",
      "2": "Two",
      "3": "Three or more",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  applicants_info: (label: string, value: any) => {
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {getFormattedApplicantsInfo(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            <div>
              {item["first-name"]} {item["last-name"]}
            </div>
            , &nbsp;
            <div>
              {item["email"]}, {item["phone"]}
            </div>
          </div>
        ))}
      </li>
    );
  },
  credit_history: (label: string, value: any) => {
    const creditLookup: { [key: string]: string } = {
      "1": "Excellent - No issues",
      "2": "Average- Paid default",
      "3": "Fair- Let's talk",
      "4": "I don't know",
    };
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            {creditLookup[item]}
          </div>
        ))}
      </li>
    ) : null;
  },
  first_home_buyer: (label: string, value: string) => {
    const buyerLookup: { [key: string]: string } = {
      "0": "No",
      "1": "Yes",
    };
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            {buyerLookup[item]}
          </div>
        ))}
      </li>
    ) : null;
  },
  employment_type: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Employee",
      "2": "Self-employed",
      "3": "Other",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  residency_status: (label: string, value: string) => {
    const residencyLookup: { [key: string]: string } = {
      "1": "Australian citizen",
      "2": "Permanent resident",
      "3": "Temporary resident",
      "4": "It’s complicated",
    };
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            {residencyLookup[item]}
          </div>
        ))}
      </li>
    ) : null;
  },
  relationship: (label: string, value: any) => {
    const relLookup: { [key: string]: string } = {
      "1": "Married",
      "2": "Single",
      "3": "De facto",
      "4": "Divorced",
      "5": "It’s complicated",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {getRelationshipInfo(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            {relLookup[item["relationship-status"]]} {item["extraInfo"]}
          </div>
        ))}
      </li>
    );
  },
  before_tax: (label: string, value: any) => {
    return getBeforeTaxInfo(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {getBeforeTaxInfo(value).map((item: any) => (
          <div className="piece-value" style={{ marginTop: 10 }}>
            Annual:&nbsp;<b>{formatCurrency(item["annual-salary"])}</b>,
            Other:&nbsp;
            <b>{formatCurrency(item["other-income"])}</b>
          </div>
        ))}
      </li>
    ) : null;
  },
  cardDebt: (label: string, value: any) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  credit_cards: (label: string, value: any) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div
            className="piece-value"
            style={{
              marginTop: 10,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            {Object.entries(item).map(([key, val]) => (
              <div key={key}>
                {key}: <b>{String(val)}</b>
              </div>
            ))}
          </div>
        ))}
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No credit cards provided</div>
      </li>
    );
  },
  loans: (label: string, value: string) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div
            className="piece-value"
            style={{
              marginTop: 10,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            {Object.entries(item).map(([key, val]) => (
              <div key={key}>
                {key}: <b>{String(val)}</b>
              </div>
            ))}
          </div>
        ))}
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No loans provided</div>
      </li>
    );
  },
  loan_rate: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  loan_amount: (label: string, value: any) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  dependant: (label: string, value: any) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div
          className="piece-value"
          style={{
            marginTop: 10,
          }}
        >
          {`${Object.keys(value).length} (${Object.values(value)
            .map((obj: any) => obj?.dependant + " years")
            .join(", ")})`}
        </div>
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No dependents provided</div>
      </li>
    );
  },
  current_lender: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  how_much_your_property: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  whatToDo: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Decrease Payments",
      "2": "Pay off loan faster",
      "3": "Get cash out",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  additional: (label: string, value: string) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div
            className="piece-value"
            style={{
              marginTop: 10,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            {Object.entries(item).map(([key, val]) => (
              <div key={key}>
                {key}: <b>{String(val)}</b>
              </div>
            ))}
          </div>
        ))}
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No additional liabilities provided</div>
      </li>
    );
  },
  step_5: (label: string, value: string) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div
          className="piece-value"
          style={{
            marginTop: 10,
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
          }}
        >
          {Object.entries(value).map(([key, val]) => (
            <div key={key}>
              {key}: <b>{formatCurrency(val)}</b>
            </div>
          ))}
        </div>
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No loans provided</div>
      </li>
    );
  },
  howSoon: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "It's urgent",
      "2": "Just investigationg options",
    };
    return (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div className="piece-value">{actionLookup[value]}</div>
      </li>
    );
  },
  income_total: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  other_income_total: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  monthlyLiability: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  monthlyLoan: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  incomeWithTaxTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  LoanAmount: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  NMS: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  HMI: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  // income: (label: string, value: string) => (
  //   <li className="info-piece">
  //     <div className="piece-title">{formatCalcName(label)}</div>
  //     <div className="piece-value">{formatCurrency(value)}</div>
  //   </li>
  // ),
  income: (label: string, value: string) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        <div
          className="piece-value"
          style={{
            marginTop: 10,
            display: "grid",
            gridTemplateColumns: "repeat(2, 1fr)",
          }}
        >
          {Object.entries(value).map(([key, val]) => (
            <div key={key}>
              {key}: <b>{formatCurrency(val)}</b>
            </div>
          ))}
        </div>
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No income provided</div>
      </li>
    );
  },
  // TODO: new object APPL
  pMs: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  priceGrowPercent: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  LMI: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  interest: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  avoidLMI: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  saveTerm: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  interestPerMonth: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  interestTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  growPrice: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  saveTermDivide: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  buyTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  depositPercent: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  rentTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  saveTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  deposit: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  price: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  rent: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  rent_term: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  save_term: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  save: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  stateShort: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  card: (label: string, value: string) => {
    return Object.values(value).length > 0 ? (
      <li className="info-piece">
        <div className="piece-title">{formatCalcName(label)}</div>
        {Object.values(value).map((item: any) => (
          <div
            className="piece-value"
            style={{
              marginTop: 10,
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
            }}
          >
            {Object.entries(item).map(([key, val]) => (
              <div key={key}>
                {key}: <b>{String(val)}</b>
              </div>
            ))}
          </div>
        ))}
      </li>
    ) : (
      <li className="info-piece">
        <div className="piece-title">No loans provided</div>
      </li>
    );
  },
  estimated: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  used: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  payment: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  interestPayment: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  repayments: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  total: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  interestCharged: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  amount: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  frequency: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  term: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  rate: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  type: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  period: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  saving: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  dutyTotal: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  transferFee: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  mortgageFee: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  stampDuty: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  value: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  state: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  property: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  situation: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  repaymentsExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  repaymentsNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  totalRepayments: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  loanTypeExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  loanTypeNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  rateExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  rateNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  // FIXME: null value start here --- 
  ongoingRateExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  fixedRateExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  fixedTermExciting: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  ongoingRateNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  fixedRateNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  fixedTermNew: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  // FIXME: end null here ...
  accessCash: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  newLoan: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  LVR: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{formatCurrency(value)}</div>
    </li>
  ),
  borrow: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  LMIwithoutDuty: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  stampDutyOnLMI: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  usage: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),

  plan: (label: string, value: string) => {
    const actionLookup: { [key: string]: string } = {
      "1": "Purchasing a Property",
      "2": "Refinancing a loan",
    };

    return <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{actionLookup[value]}</div>
    </li>
  },

  stateName: (label: string, value: string) => (
    <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">{value}</div>
    </li>
  ),
  dependants: (label: string, value: string) => {
    return typeof value === "string" ? <li className="info-piece">
      <div className="piece-title">{formatCalcName(label)}</div>
      <div className="piece-value">1&nbsp;<b>({value} years)</b></div>
    </li>
      : <div
        className="piece-value"
        style={{
          marginTop: 10,
          display: "grid",
          gridTemplateColumns: "repeat(2, 1fr)",
        }}
      >
        {Object.entries(value).map(([key, val]) => (
          <div key={key}>
            {key}: <b>{String(val)} years</b>
          </div>
        ))}
      </div>

  }
};

export default components;
